export interface BrandingSettings {
  logoWhite: string | null
  logoBlackBg: string | null
  favicon: string | null
}

export const DEFAULT_BRANDING: BrandingSettings = {
  logoWhite: '/primodrop-logo-white.png',
  logoBlackBg: null,
  favicon: null,
}
